export const en = {
    'banners-add-archived-group': "You can't add ads to archived ad groups.",
    'banners-limit-in-group': 'You can add up to {limit} ads to an ad group',
    error: 'An error has occurred',
    'no-group-found': 'Ad groups not found',
    'search-by-group': 'Search by ad groups',
    'select-campaign-for-group': 'Select a campaign in the left column'
};
